import '../core/styles/globals.css';
import 'react-dates/lib/css/_datepicker.css';
import '../components/common/DatePicker/react_dates_overrides.css';
import '../components/common/Carousel/styles.css';
import type { AppProps } from 'next/app';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Provider } from 'react-redux';
import Analytics from '../components/common/Analytics';
import ComponentWrapper from '../components/common/ComponentWrapper';
import { Locale } from '../core/constants';
import MetaTag from '../components/common/MetaTag';
import SkipTranslationWrapper from '../components/common/SkipTranslationWrapper';
import LinkTag from '../components/common/LinkTag';
import { store } from '../core/redux/store';

const queryClient = new QueryClient();

const MyApp = ({ Component, pageProps, router }: AppProps) => {
  return (
    <>
      {pageProps?.metadata && <MetaTag metadata={pageProps?.metadata} />}
      {pageProps?.links && <LinkTag links={pageProps?.links} />}
      <Analytics router={router} />
      <SkipTranslationWrapper id="app" skip={router.locale === Locale.JAPANESE}>
        <div className="flex min-h-screen flex-col text-gray-950">
          <QueryClientProvider client={queryClient}>
            <Provider store={store}>
              <ComponentWrapper Component={Component} pageProps={pageProps} router={router} />
            </Provider>
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </div>
      </SkipTranslationWrapper>
    </>
  );
};

export default MyApp;
